




















import { Component, Prop, Vue } from 'vue-property-decorator';
import SelectTeamMember from '@/components/selectTeamMember.vue';

type IUserDetailInfo = IUser.IResponse.IUserDetailInfo;

@Component({
  components: {
    SelectTeamMember,
  },
})
export default class SelectMemberModal extends Vue {
  @Prop({required: true}) private memberOptions!: IUserDetailInfo[];
  private visible = false;
  private selectedMember: string = '';

  public showModal() {
    this.visible = true;
  }
  public closeModal() {
    this.visible = false;
    this.selectedMember = '';
  }
  public handleSubmit() {
    this.$emit('change', this.selectedMember);
    this.closeModal();
  }
}
